module.exports = __webpack_public_path__ + "images/171_2048.jpg";